var exports = {
  "i": "xaee3c4fa--5c512d--wrapper",
};

module.exports = exports;
